export interface OAuthLogger {
  log(...args: unknown[]): void;
  warn(...args: unknown[]): void;
}

export const noopLogger: OAuthLogger = {
  log: () => { /* no-op */ },
  warn: () => { /* no-op */ },
};
